export default "__VITE_ASSET__4fbea0ab__"